import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';

import agrosmartVideo from "./Agrosmart_images/agrosmart video.mp4";

const AgroSmart = () => {
    const mediaItems = [
        {
            type: 'video',
            src: agrosmartVideo
        },
        {
            type: 'youtube',
            src: 'https://www.youtube.com/embed/X3-XpjcJm8U?start=5'
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">AgroSmart</h2>
        <span className="section__subtitle">AI-Powered Agricultural Platform</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>AgroSmart is a comprehensive AI-powered agricultural platform that revolutionizes modern farming through advanced computer vision and machine learning technologies.</p>
                <br />
                <p className='redRadio__text'><strong>Key Features:</strong></p>
                <br />
                <p className='redRadio__text'>🌱 <strong>Plant Disease Detection</strong></p>
                <br />
                <p className='redRadio__text'>🌿 <strong>Weed Detection & Management</strong>.</p>
                <br />
                <p className='redRadio__text'>📊 <strong>Smart Crop Prediction</strong></p>
                <br />
                <p className='redRadio__text'>🚀 <strong>Flask Web Application</strong></p>
                <br />
                <p className='redRadio__text'>This platform empowers farmers with data-driven insights, helping them make informed decisions to increase productivity, reduce losses, and promote sustainable farming practices.</p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">TensorFlow</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">OpenCV</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Flask</h3>
                <span className="skills__level"></span>
            </div>
            </div>
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Keras</h3>
                <span className="skills__level"></span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">YOLOv8</h3>
                <span className="skills__level"></span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">NumPy</h3>
                <span className="skills__level"></span>
              </div>
            </div>
          
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Pandas</h3>
              <span className="skills__level"></span>
            </div>
          </div>
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default AgroSmart;